import { PAYWALLED_CONTENT_SELECTORS, TabsEnum } from '~/pages/SingleVideoPage/const';
import { Video } from '~/types';
import { replaceQuotes } from '~/utils/stringUtils';

const checkSummaryExists = (summary) => {
  if (summary) {
    const parsed = JSON.parse(summary);
    return parsed && Array.isArray(parsed) && parsed.length > 0;
  } else {
    return false;
  }
};

export const getTabs = (video?: Video | null) => {
  if (video) {
    const arr = [
      {
        tab: TabsEnum.Overview,
        condition: Boolean(video.key_learning_objectives || video.executive_summary),
      },
      {
        tab: TabsEnum.Summary,
        condition: checkSummaryExists(video.summary),
      },
      {
        tab: TabsEnum.Expert,
        condition: true,
      },
      {
        tab: TabsEnum.Reviews,
        condition: true,
      },
    ];

    const res = {};
    let index = 0;

    arr.forEach((item) => {
      if (item.condition) {
        res[item.tab] = index;
        index++;
      }
    });

    return res;
  } else {
    return {};
  }
};

export const getVideoPageJsonData = (
  title = '',
  description = '',
  keyLearningObjectives: (string | undefined)[] | undefined = [],
) => {
  const _title = replaceQuotes(title);
  const _description = replaceQuotes(description);
  const _keyLearningObjectives = keyLearningObjectives.map((item) =>
    item ? replaceQuotes(item) : item,
  );
  return `{
    "@context": "https://schema.org",
    "@type": "Course",
    "name": "${_title}",
    "description": "${_description}",
    "provider": {
        "@type": "Organization",
        "name": "Finance Unlocked",
        "sameAs": "https://financeunlocked.com"
    },
    "teaches": "${_keyLearningObjectives.join(', ')}",
    "learningResourceType": "video",
    "isAccessibleForFree": "False",
    "hasPart": [
      {
        "@type": "WebPageElement",
        "isAccessibleForFree": "True",
        "cssSelector": ".${PAYWALLED_CONTENT_SELECTORS.OVERVIEW}"
      }, {
        "@type": "WebPageElement",
        "isAccessibleForFree": "True",
        "cssSelector": ".${PAYWALLED_CONTENT_SELECTORS.SUMMARY}"
      }, {
        "@type": "WebPageElement",
        "isAccessibleForFree": "False",
        "cssSelector": ".${PAYWALLED_CONTENT_SELECTORS.VIDEO_PLAY_BTN}"
      }, {
        "@type": "WebPageElement",
        "isAccessibleForFree": "False",
        "cssSelector": ".${PAYWALLED_CONTENT_SELECTORS.VIDEO_PLAY_BTN_SMALL}"
      }, {
        "@type": "WebPageElement",
        "isAccessibleForFree": "False",
        "cssSelector": ".${PAYWALLED_CONTENT_SELECTORS.JOIN_US}"
      }
    ]
  }`;
};

export const getRelatedVideosToDisplay = (
  relatedVideos: (Video | null)[] | null | undefined,
  nextVideoInPathwayId?: string | null,
) => {
  return relatedVideos
    ? relatedVideos.filter((item) => item?.id !== nextVideoInPathwayId).slice(0, 8)
    : [];
};
